export function truncateString(str: string, maxLength: number): string {
  if (str.length <= maxLength) {
    return str;
  }
  return str.substring(0, maxLength) + '...';
}

export function getFirstName(fullName: string): string | null {
  return fullName.split(' ')[0];
}
